import { NgModule } from '@angular/core';
import { UiCommonModule, RegHubDateAdapter, REG_HUB_DATE_FORMATS } from 'reg-hub-common';
import { environment } from '../../environments/environment'
import { ReportsComponent } from './reports/reports.component';
import { ReportsRoutingModule } from './reporting-routing.module';
import { SharedModule } from 'projects/reg-hub-admin/src/app/shared/shared.module';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { TemplateReportComponent } from './template-report/template-report.component';
import { LiveTemplateReportComponent } from './live-template-report/live-template-report.component';
import { SavedTemplateReportsListComponent } from './saved-template-reports-list/saved-template-reports-list.component';
import { ReportTemplatesListComponent } from './report-templates-list/report-templates-list.component';
import { RequestedReportsListComponent } from './requested-reports-list/requested-reports-list.component';
import { RequestedReportsFilterComponent } from './requested-reports-filter/requested-reports-filter.component';
import { SavedTemplatesReportsFilterComponent } from './saved-template-reports-filter/saved-template-reports-filter.component';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
  declarations: [
    ReportsComponent,
    ReportTemplatesListComponent,
    TemplateReportComponent,
    RequestedReportsFilterComponent,
    RequestedReportsListComponent,
    LiveTemplateReportComponent,
    SavedTemplateReportsListComponent,
    SavedTemplatesReportsFilterComponent
  ],
  imports: [
    TranslocoModule,
    ReportsRoutingModule,
    SharedModule,
    UiCommonModule.forRoot({ rootUrl: environment.urlAddress, batchRootURL: environment.batchUrlAddress, consortiumRootURL: environment.consortiumUrlAddress }),
  ],
  providers: [
    { provide: DateAdapter, useClass: RegHubDateAdapter},
    { provide: MAT_DATE_FORMATS, useValue: REG_HUB_DATE_FORMATS }
  ]
})
export class ReportsModule { }